import Image from '@components/Image';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import CloseLineIcon from '@icons/CloseLineIcon';
import {
  Dispatch, SetStateAction, useEffect, useRef, useState,
} from 'react';
import { createPortal } from 'react-dom';

import styles from './styles.module.scss';

interface Props {
    images: string[];
    isOpen: boolean;
    setIsOpen: Dispatch<SetStateAction<boolean>>;
}

function ItemImages({ images, isOpen, setIsOpen }:Props) {
  const [index, setIndex] = useState<number>(0);
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (isOpen) {
      ref.current?.classList.remove(styles.none);
      const timeout = setTimeout(() => {
        ref.current?.classList.remove(styles.hide);
      }, 100);
      return () => clearTimeout(timeout);
    }
    ref.current?.classList.add(styles.hide);
    const timeout = setTimeout(() => {
      ref.current?.classList.add(styles.none);
    }, 300);
    return () => clearTimeout(timeout);
  }, [isOpen]);
  return (
        <div className={`${styles.wrapper} ${styles.hide} ${styles.none}`}
             ref={ref} >
            <div className={styles.container}>
                <Row className={styles.images}
                     fullWidth
                     onScroll={(e) => {
                       const { scrollLeft, scrollWidth, offsetWidth } = e.currentTarget;
                       setIndex(Math.round(scrollLeft / (scrollWidth - offsetWidth)));
                     }} >
                    {images.map((image, idx) => (
                        <Image src={image}
                               className={styles.image}
                               key={`${image} ${idx}`}
                               width={400}
                               height={200}
                               alt='상품 상세 이미지' />
                    ))}
                </Row>
                <Text size='xl' color={colors.white} fontWeight='medium'>
                    {index + 1 } /  {images.length}

                </Text>
                <CloseLineIcon className={styles.close}
                           size={36}
                           color={colors.white}
                           onClick={() => setIsOpen(false)} />
            </div>
        </div>
  );
}

const component = (props: Props) => createPortal(<ItemImages {...props}/>, document.body);

export default component;
